import React, { useState } from 'react';
import PropTypes from 'prop-types';
import API from 'config/ApiConfig';

export default function CreateUserForm({ onSubmit }) {
  // State for form fields
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    role: 'siswa',
    telepon: '',
  });

  // State for errors
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  // Handle input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Validate form fields
  const validate = () => {
    const errors = {};
    if (!formData.username) errors.username = 'Username is required';
    if (!formData.password) errors.password = 'Password is required';
    if (!formData.telepon) errors.telepon = 'Telepon is required';
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form submission
    // const API_BASE_URL = 'http://localhost:5000/api/admin/user';
  const API_BASE_URL = API.API_ADMIN + '/user';
    const JWT_TOKEN = localStorage.getItem('authToken'); // Ganti dengan token yang valid
    function getAuthHeaders() {
        return {
            'Authorization': `Bearer ${JWT_TOKEN}`, 
            'Content-Type': 'application/json' 
        };
    }
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validate()) {
      try {
        const response = await fetch(API_BASE_URL, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log('User created:', data);

        // Reset form and errors on successful submit
        setFormData({
          username: '',
          password: '',
          role: 'siswa',
          telepon: '',
        });
        setErrors({});
        if (onSubmit) onSubmit(data); // Optional: Callback on success
      } catch (error) {
        console.error('Error creating user:', error);
      }
    }
  };
  const handleClick = () => {
    alert('Berhasil Membuat User');
    window.location.href = '/admin/user';
  }

  return (
    <div className="">
       <h3 className= "font-bold uppercase text-lg text-blueGray-700 align-center m-4" >Tambah User</h3>
    <form onSubmit={handleSubmit} className="space-y-2">
      <div>
        <span class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i class="fas fa-at"></i>
        </span>
        <input
          type="text"
          name="username"
          value={formData.username}
          onChange={handleChange}
          placeholder='Username/Email'
          className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
        />
        {errors.username && <p className="text-red-500 text-xs">{errors.username}</p>}
      </div>

      <div>
        <span class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i class="fas fa-star-of-life"></i>
        </span>
        <input
          type="password"
          name="password"
          value={formData.password}
          placeholder='Password'
          onChange={handleChange}
          className="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
        />
        {errors.password && <p className="text-red-500 text-xs">{errors.password}</p>}
      </div>

      <div>
        <span class=" mt-4 z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i class="fas fa-user-cog"></i>
        </span>
        <select
          name="role"
          value={formData.role}
          onChange={handleChange}
          className="mt-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
        >
          <option value="admin">Admin</option>
          <option value="tentor">Tentor</option>
          <option value="siswa">Siswa</option>
        </select>
      </div>

      <div>
        <span class=" mt-4 z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i class="fas fa-phone"></i>
        </span>
        <input
          type="text"
          name="telepon"
          value={formData.telepon}
          placeholder='Nomor Telepon'
          onChange={handleChange}
          className=" mt-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
        />
        {errors.telepon && <p className="text-red-500 text-xs">{errors.telepon}</p>}
      </div>

      <div>
       <button
          type="submit"
          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          onClick={handleClick}
        >
          Create User
        </button>
        <a href="/admin/user"><button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Cancel
            </button></a>
      </div>
    </form>
    </div>
  );
}

CreateUserForm.propTypes = {
  onSubmit: PropTypes.func,
};

